<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="clients-consent-policy">
    <div class="clients-consent-policy__header">
      <div class="clients-consent-policy__title">
        Согласие на обработку персональных данных Заказчиков
      </div>
      <div class="clients-consent-policy__date">
        Дата публикации:
        <time class="clients-consent-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="clients-consent-policy__list">
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            Настоящим я, в соответствии с требованиями Федерального закона от 27.07.2006 №
            152-ФЗ «О персональных данных», свободно, своей волей и в своем интересе даю
            согласие Обществу с ограниченной ответственностью «ЛИГАЛ АДС ТЕХ» (ОГРН
            1227700103245, ИНН 9709078420, далее — Оператор) на обработку моих
            персональных данных на изложенных ниже условиях.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">
          1. Перечень обрабатываемых персональных данных
        </div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            1.1. Фамилия, имя, отчество (при указании);
          </p>
          <p class="clients-consent-policy__item-paragraph">1.2. Номер телефона;</p>
          <p class="clients-consent-policy__item-paragraph">
            1.3. Адрес электронной почты;
          </p>
          <p class="clients-consent-policy__item-paragraph">1.4. Регион;</p>
          <p class="clients-consent-policy__item-paragraph">
            1.5. Содержание запросов и обращений (включая описание ситуации в формах Сайта
            и сообщенное по телефону);
          </p>
          <p class="clients-consent-policy__item-paragraph">
            1.6. Сведения о записях на консультации, заявках и иных обращениях и их
            статусах;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            1.7. Аудиозаписи телефонных разговоров с операторами Оператора;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            1.8. IP-адрес, файлы cookies и аналогичные данные;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            1.9. Данные, собираемые метрическими программами (например, Яндекс.Метрика);
          </p>
          <p class="clients-consent-policy__item-paragraph">
            1.10. Иные данные, предоставленные мной Оператору.
          </p>
          <p class="clients-consent-policy__item-paragraph">
            Предоставляя указанные сведения, я гарантирую их достоверность и владение ими
            на законном основании.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">2. Цели обработки</div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            2.1. Прием, оформление и сопровождение моих обращений независимо от способа их
            поступления (записи на консультации, заявки на подбор специалиста, заявки на
            услуги, вопросы, телефонные обращения), включая уведомления об их статусе по
            СМС, электронной почте и иным каналам;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            2.2. Подбор исполнителя по моему обращению и передача моих контактных данных и
            содержания обращения специалисту, выбранному мной, либо исполнителю,
            подобранному по моему обращению, — специалисту, разместившему профиль на
            Сайте, или юристу (юридической компании) — партнеру Оператора — в целях
            оказания мне юридической помощи;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            2.3. Связь со мной по вопросам моих обращений, в том числе по телефону;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            2.4. Запись телефонных разговоров с операторами Оператора в целях контроля
            качества и подтверждения фактов обращений;
          </p>
          <p class="clients-consent-policy__item-paragraph">
            2.5. Направление сообщений рекламного и информационного характера (согласие на
            получение рекламных сообщений предоставляется отдельным действием и может быть
            отозвано в любой момент);
          </p>
          <p class="clients-consent-policy__item-paragraph">
            2.6. Поддержание и улучшение функций Сайта, статистические исследования на
            основе обезличенных данных.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">
          3. Перечень действий с персональными данными
        </div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
            изменение), извлечение, использование, передача (предоставление, доступ),
            обезличивание, блокирование, удаление, уничтожение — с использованием средств
            автоматизации и без них.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">
          4. Передача персональных данных
        </div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            4.1. Мои контактные данные и содержание обращения передаются исполнителю в
            целях, указанных в п. 2.2: специалисту, выбранному мной, либо специалисту или
            партнеру Оператора, подобранному по моему обращению. До принятия моего
            обращения в работу конкретным исполнителем сведения о нём предоставляются
            возможным исполнителям без моих контактных данных; контактные данные
            раскрываются только исполнителю, принявшему обращение в работу.
          </p>
          <p class="clients-consent-policy__item-paragraph">
            4.2. Оператор вправе поручить обработку моих персональных данных третьим лицам
            на основании заключаемых с ними договоров, включая: провайдеров хостинга,
            операторов связи и сервисы телефонии, поставщиков CRM-систем и систем
            обработки обращений, сервисы рассылок, поставщиков аналитических услуг. Такие
            лица обрабатывают данные по указаниям Оператора и обязаны соблюдать требования
            Федерального закона № 152-ФЗ.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">
          5. Срок действия и отзыв согласия
        </div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            5.1. Согласие действует с момента предоставления до его отзыва.
          </p>
          <p class="clients-consent-policy__item-paragraph">
            5.2. Согласие может быть отозвано путем направления заявления Оператору: по
            электронной почте
            <a class="clients-consent-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >, заказным почтовым отправлением по юридическому адресу Оператора либо личным
            вручением уполномоченному представителю Оператора.
          </p>
          <p class="clients-consent-policy__item-paragraph">
            5.3. В случае отзыва Оператор прекращает обработку и уничтожает персональные
            данные в срок, установленный законодательством, за исключением случаев, когда
            обработка может быть продолжена на основаниях, предусмотренных законом.
          </p>
        </div>
      </li>
      <li class="clients-consent-policy__item">
        <div class="clients-consent-policy__item-title">6. Заключительные положения</div>
        <div class="clients-consent-policy__item-text">
          <p class="clients-consent-policy__item-paragraph">
            6.1. Я подтверждаю, что ознакомлен(а) с Политикой в области обработки и
            обеспечения защиты персональных данных Оператора и положениями Федерального
            закона № 152-ФЗ.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.clients-consent-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
